<template>
  <mp-error v-if="isError === true"></mp-error>
  <div v-else class="game-input-on-background-wrapper" :style="getStyle(startGameConfig)" :id="startGameConfig.id">
    <div class="main-image-container" :style="getImageStyle(imageData)"></div>
    <div class="game-container" v-for="(item, index) in items" :key="'st_' + index" :style="getItemStyle(item)">
      <div v-if="typeof item.title == 'string'" class="titleTxt">{{ item.title }}</div>
      <div
        class="text"
        @mousedown="startSelect"
        @mouseup="stopSelect"
        @mouseover="moveSelect"
        v-html="selecteble[index].innerHTML"
        ref="selecteble"
        :class="[{ 'block-game-after-correct': gameStatus }]"
      ></div>
      <div v-if="typeof item.author == 'string'" class="author">{{ item.author }}</div>
      <div
        :style="startGameConfig.isDev == true ? 'display:block' : 'display:none'"
        class="text"
        v-html="correct[index].innerHTML"
      ></div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import * as fJS from '../../mixins/cjsRoot/fJS';
import mpError from '../MpError/MpError';
export default {
  name: 'mp-text-select',
  components: { mpError },
  props: {
    startGameConfig: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      // startData: {},
      imageData: null,
      items: [],
      selecteble: [],
      correct: [],
      initData: {},
      gameStatus: false,
      isError: false,
    };
  },
  beforeMount() {
    this.initGame();
    this.newGame();
    this.imageData = this.startGameConfig.mainImage;
  },
  mounted() {
    for (let i = 0; i < this.selecteble.length; i++) {
      if (this.selecteble[i].childNodes.length != this.correct[i].childNodes.length) {
        this.isError = true;
        console.log(
          'W sample: ' +
            i +
            ' ' +
            'tekst do zaznaczania(' +
            this.selecteble[i].childNodes.length +
            ') nie jest równy tekstowi z odpowiedziami(' +
            this.correct[i].childNodes.length +
            ').'
        );
        // for (let i = 0; i < check.childNodes.length; i++) {
        //   if (typeof this.correct.childNodes[i] == 'undefined') break;
        //   console.log(check.childNodes[i].innerHTML + ' - ' + this.correct.childNodes[i].innerHTML);
        // }
      }
    }
    if (this.isError == true) {
      console.log('SPRAWDŹ CZY TEKSTY SĄ RÓWNE JEŻELI TAK, A MIMO WSZYSTKO TO WIDZISZ');
      console.log('POWIEDZ AUTORCE, ŻEBY TO NAPRAWIŁA!!! F***!!!');
    }
  },
  methods: {
    initGame() {
      this.selecteble.splice(0, this.selecteble.length);
      this.correct.splice(0, this.correct.length);

      if (this.startGameConfig.shuffle === true) {
        this.items = _.shuffle(this.startGameConfig.sample);
      } else {
        this.items = this.startGameConfig.sample;
        // console.log('jakies items', this.items);
      }

      for (let i = 0; i < this.items.length; i++) {
        let loadTxt = '',
          forward = false;
        const txt = this.items[i].txt.split('');
        // console.log(txt);
        this.selecteble[i] = document.createElement('div');
        for (let j = 0; j < txt.length; j++) {
          if (txt[j] == '<') {
            forward = true;
          }
          if (forward == true && txt[j] == 'b' && txt[j + 1] == 'r') {
            loadTxt += '<br />';
          }
          if (forward == true && txt[j] == 'i') {
            loadTxt += "<span style='font-family: Myriad Pro Italic' class='italic-class'>";
          }
          if (forward == true && txt[j] == '/' && txt[j + 1] == 'i') {
            loadTxt += '</span>';
            txt[j] = '';
            txt[j + 1] = '';
            txt[j + 2] = '';
            forward = false;
          }
          if (forward == false) {
            loadTxt += '<span class="e">' + txt[j] + '</span>';
          }
          if (forward == true && txt[j] == '>') {
            forward = false;
          }
        }

        this.correct[i] = document.createElement('div');
        const cor = this.items[i].txt2.split('');
        let cls = 'e',
          correct = '';
        forward = false;

        for (let j = 0; j < cor.length; j++) {
          if (cor[j] == '<') {
            forward = true;
          }

          if (forward == true && cor[j] == 'b' && cor[j + 1] == 'r') {
            correct += '<br />';
          }
          if (forward == true && cor[j] == 'i') {
            correct += `<span style='font-family: Myriad Pro Italic' class='italic-class'>`;
          }
          if (forward == true && cor[j] == '/' && cor[j + 1] == 'i') {
            correct += '</span>';
            cor[j] = '';
            cor[j + 1] = '';
            cor[j + 2] = '';
            forward = false;
          }

          if (cor[j] == '/' && cor[j + 1] == '#') {
            cls = 'e';
          }
          if (forward == true && cor[j - 1] != '/' && cor[j] == '#') {
            cls = 'g';
          }

          if (forward == false) {
            correct += '<span class="' + cls + '">' + cor[j] + '</span>';
          }

          if (forward == true && cor[j] == '>') {
            forward = false;
          }
        }
        this.correct[i].innerHTML = correct;
        this.selecteble[i].innerHTML = loadTxt;
      }
    },
    newGame() {
      this.gameStatus = false;
      this.initData = { mouseDown: false, move: false, child: -1 };
    },
    findIndxChild(nodes, child) {
      var indx = -1;
      nodes.forEach(function (node, i) {
        if (node == child) {
          indx = i;
          return;
        }
      });
      return indx;
    },
    startSelect(e) {
      // console.log('TEST', e);
      /**
       * if checkStatus is active, reset it
       */
      this.resetCheckStatus();
      if (e.target.tagName.toLowerCase() !== 'span') return;
      this.initData.mouseDown = true;
      this.initData.child = this.findIndxChild(e.target.parentNode.childNodes, e.target);
      switch (e.target.className) {
        case 'e':
          e.target.className = 's';
          break;
        case 'g':
          break;
        default:
          e.target.className = 'e';
      }

      // await this.$nextTick();
      e.preventDefault();
    },
    stopSelect(e) {
      this.initData.mouseDown = false;
      if (!this.initData.move) return;
      else this.initData.move = false;
      this.initData.child = -1;

      // await this.$nextTick();
      e.preventDefault();
    },
    moveSelect(e) {
      if (e.target.tagName.toLowerCase() !== 'span') return;
      if (!this.initData.mouseDown) return;
      if (!this.initData.move) this.initData.move = true;
      let indx = this.findIndxChild(e.target.parentNode.childNodes, e.target);
      var clss = e.target.parentNode.childNodes[this.initData.child].className;
      if (Math.abs(this.initData.child - indx) > 0) {
        if (indx > this.initData.child) {
          for (let i = this.initData.child + 1; i <= indx; i++) {
            clss = 's';
            if (
              e.target.parentNode.childNodes[i].className != 'g' &&
              e.target.parentNode.childNodes[i].className != 'italic-class'
            ) {
              e.target.parentNode.childNodes[i].className = clss;
            }
          }
        } else {
          for (let i = this.initData.child; i >= indx; i--) {
            if (clss == 'b') {
              clss = 's';
            }
            if (
              e.target.parentNode.childNodes[i].className != 'g' &&
              e.target.parentNode.childNodes[i].className != 'italic-class'
            ) {
              e.target.parentNode.childNodes[i].className = clss;
            }
          }
        }
      }

      // await this.$nextTick();
      e.preventDefault();
    },
    letterTestWrong(correct, node, innerIndex, outerIndex) {
      if (node.className == 'e') {
        return;
      }
      if (node.className == 's' && correct.childNodes[innerIndex].className != 'g') {
        node.className = 'b';
        return;
      }

      if (
        node.childNodes[innerIndex - 1] != null &&
        ((node.childNodes[innerIndex - 1].className == 's' && correct.childNodes[innerIndex - 1].className != 'g') ||
          (node.childNodes[innerIndex - 1].className == 'e' && correct.childNodes[innerIndex - 1].className == 'g') ||
          node.childNodes[innerIndex - 1].className == 'b')
      ) {
        node.className = 'b';
      }

      if (
        node.childNodes[innerIndex + 1] != null &&
        ((correct.childNodes[innerIndex + 1].className == 'g' && node.childNodes[innerIndex + 1].className == 'e') ||
          (correct.childNodes[innerIndex + 1].className != 'g' && node.childNodes[innerIndex + 1].className == 's'))
      ) {
        for (let k = i; k >= 0; k--) {
          if (node.childNodes[k].className == 's' || node.childNodes[k].className == 'g')
            node.childNodes[k].className = 'b';
          else break;
        }
      }
    },
    letterTesGood(correct, node, innerIndex, outerIndex) {
      if (node.className == 's') {
        node.className = 'g';
      }
    },
    checkWrongs() {
      let self = this;
      for (let j = 0; j < this.$refs.selecteble.length; j++) {
        this.$refs.selecteble[j].childNodes.forEach((node, i) => {
          if (node.className === 'italic-class') {
            node.childNodes.forEach(function (nestedNode, innerIndex) {
              self.letterTestWrong(self.correct[j].childNodes[i], nestedNode, innerIndex, 0);
            });
          } else {
            self.letterTestWrong(self.correct[j], node, i, j);
          }
        });
      }
    },
    /**
     * uncheck all WRONGCOLOR class and reset to default
     * @method uncheckWrongs
     */
    uncheckWrongs() {
      let arrayElem = document.querySelectorAll('.b');
      arrayElem.forEach(function (item) {
        item.classList.remove('b');
        item.classList.add('e');
      });
    },
    /**
     * check for wrong selection and if time is set reset it after delay
     * @method checkWrongsAction
     * @param  {Number}          time delay in miliseconds
     */
    checkWrongsAction(time) {
      /** default checkWrongs function */
      this.checkWrongs();
      /** if delay time exist and is a Number */
      if (_.isNumber(time)) {
        setTimeout(() => {
          this.uncheckWrongs();
        }, time);
      }
    },
    checkGood() {
      let self = this;
      for (let j = 0; j < this.$refs.selecteble.length; j++) {
        this.$refs.selecteble[j].childNodes.forEach(function (node, i) {
          if (node.className === 'italic-class') {
            node.childNodes.forEach(function (nestedNode, innerIndex) {
              self.letterTesGood(self.correct[j].childNodes[i], nestedNode, innerIndex, 0);
            });
          } else {
            self.letterTesGood(self.correct[j], node, i, j);
          }
        });
      }
    },
    clearChecks() {
      for (let i = 0; i < this.$refs.selecteble.length; i++) {
        this.$refs.selecteble[i].childNodes.forEach(function (node, j) {
          if (node.className == 'b' || node.className == 's') {
            node.className = 'e';
          }
        });
      }
    },
    resetGameAction() {
      this.initGame();
      this.newGame();
      this.resetBgColor();
    },

    /** @resetBgColor  reset geme and gice 'e' class witch means empty ;) */

    resetBgColor() {
      this.$refs.selecteble[0].childNodes.forEach(function (node) {
        if (node.className === 'italic-class') {
          node.childNodes.forEach(function (nestedNode) {
            nestedNode.classList.remove('b');
            nestedNode.classList.remove('g');
            nestedNode.classList.remove('s');
            nestedNode.classList.add('e');
          });
        } else {
          node.classList.remove('b');
          node.classList.remove('g');
          node.classList.remove('s');
          node.classList.add('e');
        }
      });
    },

    resetCheckStatus() {
      this.$store.dispatch('resetCheckStatus');
      /** @type {Boolean}  return true becouse want to event to propagate  */
      return true;
    },
    checkGameAction() {
      let isCorrect = true;
      for (let j = 0; j < this.$refs.selecteble.length; j++) {
        this.$refs.selecteble[j].childNodes.forEach(function (node, i) {
          if (node.className == 'b') node.className = 's';
        });
      }
      /** search and mark wrong selection */
      this.checkWrongsAction(1000);
      if (this.startGameConfig.showGood) this.checkGood();

      for (let j = 0; j < this.$refs.selecteble.length; j++) {
        for (let i = 0; i < this.$refs.selecteble[j].childNodes.length; i++) {
          if (
            this.$refs.selecteble[j].childNodes[i].className == 'b' ||
            (this.$refs.selecteble[j].childNodes[i].className == 'e' && this.correct[j].childNodes[i].className == 'g')
          ) {
            console.log(
              this.$refs.selecteble[j].childNodes[i].className +
                ' - ' +
                this.correct[j].childNodes[i].className +
                ': ' +
                this.correct[j].childNodes[i].innerHTML
            );
            isCorrect = false;
          }
        }
      }

      if (isCorrect) {
        for (let j = 0; j < this.$refs.selecteble.length; j++) {
          for (let i = 0; i < this.$refs.selecteble[j].childNodes.length; i++) {
            this.$refs.selecteble[j].childNodes[i].className = this.correct[j].childNodes[i].className;
          }
        }
      } else if (this.startGameConfig.isClear && !this.startGameConfig.showWrong) {
        this.clearChecks();
      }

      this.gameStatus = isCorrect;
      return isCorrect;
    },
    getImageStyle(imageData) {
      if (_.isObject(imageData) && imageData.imagePath) {
        if (!imageData.pos) {
          imageData = Object.assign({}, imageData, {
            pos: {
              x: 0,
              y: 0,
            },
          });
        }
        if (!imageData.height) {
          imageData = Object.assign({}, imageData, {
            height: 1080,
          });
        }
        if (!imageData.width) {
          imageData = Object.assign({}, imageData, {
            width: 1920,
          });
        }
      } else {
        return 'display : none;';
      }
      return _.merge({ position: 'absolute', left: '0' }, this.getCustomStyle(imageData), {
        'background-image': `url(${require(`__staticDir/${this.$store.getters.multibookType}/${this.giveMeImagePlease(
          imageData.imagePath
        )}`)})`,
        top: fJS.isNumeric(imageData.pos.y)
          ? imageData.pos.y + 'px'
          : fJS.isNumeric(imageData.offsetVertical)
          ? imageData.offsetVertical
          : 0,
        left: fJS.isNumeric(imageData.pos.x)
          ? imageData.pos.x + 'px'
          : fJS.isNumeric(imageData.offsetHorizontal)
          ? imageData.offsetHorizontal
          : 0,
        width: fJS.isNumeric(imageData.width) ? imageData.width + 'px' : '100%',
        height: fJS.isNumeric(imageData.height) ? imageData.height + 'px' : '100%',
      });
    },
    getCustomStyle(item) {
      let customStyle = {};
      if (item && item.cssStyle) {
        if (_.isObject(item.cssStyle)) {
          customStyle = _.mapKeys(item.cssStyle, function (value, key) {
            return _.toString(key);
          });
        }
      }
      return customStyle;
    },
    getItemStyle(item) {
      if (this.startGameConfig.cssItems) {
        return _.merge({}, this.startGameConfig.cssItems, this.getCustomStyle(item));
      }
      return this.getCustomStyle(item);
    },
    getStyle(item) {
      let width = '1920px';
      let height = '1080px';
      if (item && item.cssStyle) {
        (width = item.cssStyle.width || width), (height = item.cssStyle.height || height);
      }
      return _.merge({}, { width: width, height: height }, this.getCustomStyle(item));
    },
    giveMeImagePlease(p) {
      let path = require('path');
      let imgPath = p;
      imgPath = imgPath.replace('static/', '');
      imgPath = path.normalize(imgPath);
      return imgPath;
    },
  },
  computed: {
    checkGame() {
      return this.$store.getters.checkGame;
    },
    resetGameSwitch() {
      return this.$store.getters.resetGame;
    },
  },
  watch: {
    checkGame: function (newStatus, oldStatus) {
      if (newStatus) {
        this.$store.dispatch('checkGame', this.checkGameAction());
        this.$store.commit('CHECK_GAME', false);
      }
    },
    resetGameSwitch(newStatus, oldStatus) {
      if (newStatus) {
        this.resetGameAction();
        this.$store.dispatch('resetGame');
      }
    },
  },
};
</script>
<style lang="scss">
.e {
  background-color: transparent;
  cursor: pointer;
}

.s {
  background-color: #82eeff;
  cursor: pointer;
}

.b {
  background-color: #fc3a3a;
  cursor: pointer;
}

.g {
  background-color: #50ff47;
  cursor: not-allowed;
}
</style>
<style lang="scss" scoped>
.game-input-on-background-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  position: inherit;
  // background-image: url("~@/assets/icons/przybornik_kosz.png");
  .game-container {
    position: relative;
    display: block;
    width: 100%;
    height: 100%;
    text-align: 'justify';

    background-size: contain;
    background-repeat: no-repeat;
  }
}

.game-container .titleTxt {
  top: 0;
  font-weight: bolder;
  font-size: 1.5em;
  margin-bottom: 50px;
}

.game-container .author {
  font-style: italic;
  font-weight: normal;
  font-size: 0.7em;
  text-align: right;
  margin-top: 50px;
}
.block-game-after-correct {
  pointer-events: none;
}
.main-image-container,
.main-txt-container {
  display: block;
  width: 100%;
  height: 100%;
  z-index: -1;
  background-size: contain;
  background-repeat: no-repeat;
}
</style>
